import React from 'react'

import SvgIcon from '@/components/SvgIcon'
import './index.less'

const HBlockAdd: React.FC<any> = ({ onClick, text = '添加' }) => {
  return (
    <div className='h-block-add'>
      <SvgIcon name='cross-box' className='h-block-add-icon' />
      <span className='h-block-add-text' onClick={onClick}>
        {text}
      </span>
    </div>
  )
}

export default HBlockAdd
